export const SHOPIFY_DATA = {
    recommend: [],
    cart: [],
    errormsg: '',
};

// donation_type is an object that contains only the following attributes:
// * id
// * name
// * category
export function save_recommend_data(donation_type, position, collection_title) {
    SHOPIFY_DATA.recommend.push({
        donation_type,
        position,
        collection_title,
    });
}

// item is an object that contains only the following attributes:
// * id
// * title
// * price
// * quantity
// * variant_sku
// * variant_id
// * url
// * category
// * type
export function save_item_data(
    item,
    item_title,
    position,
    category,
    age,
    country,
    gender,
    collection_title
) {
    SHOPIFY_DATA.cart.push({
        item,
        item_title,
        position,
        category,
        age,
        country,
        gender,
        collection_title,
    });
}
